export const leaderboardContent = {
  title: "National Leaderboard",
  filters: [
    { id: "all", label: "All Region" },
    { id: "usa", label: "USA" },
    { id: "australia", label: "Australia" },
    { id: "passing", label: "Passing (under 1 min)" },
    { id: "failing", label: "Failing (over 1 hr)" },
  ],
  columns: ["Company Name", "Location", "Status / Score", "First Response"],
}
